import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { BrandUtil, EmotionBreakpoint } from 'dw-us-ui';

const Layout = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 920px;
	width: 100%;
	hr {
		width: 920px;
		border: none;
		height: 1px;
		background-color: ${(props) =>
			props.hrbackgroundcolor ? props.hrbackgroundcolor : 'rgba(0, 0, 0, 0)'};
		margin: 0 !important;
		${EmotionBreakpoint('tablet')} {
			width: 700px;
		}
	}
	${EmotionBreakpoint('mobile')} {
		padding: 2rem;
		hr {
			width: 340px;
			border: none;
			height: 1px;
			background-color: ${(props) =>
				props.hrbackgroundcolor ? props.hrbackgroundcolor : 'rgba(0, 0, 0, 0)'};
			margin: 0 !important;
		}
	}
	${EmotionBreakpoint('tablet')} {
		max-width: 700px;
	}
`;
const HeadLineContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	${EmotionBreakpoint('mobile')} {
		max-width: 340px;
		width: 100%;
		height: 100%;
	}
`;

const Headline = styled.h2`
	color: #000;
	text-align: center;
	font-family: escrow;
	font-size: 48px;
	font-style: normal;
	font-weight: 500;
	line-height: 45.6px;
	letter-spacing: -0.48px;
	${EmotionBreakpoint('mobile')} {
		font-size: 29px;
		line-height: 35.7px;
	}
	.law & {
		font-family: 'Oswald', sans-serif;
	}
`;
const SubHeadline = styled.h5`
	color: #222;
	text-align: center;
	font-family: Arial, sans-serif;
	font-size: 19px;
	font-style: normal;
	font-weight: 400;
	line-height: 26.4px;
	.law & {
		font-family: Noto serif;
	}
`;
const FaqContianer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: self-start;
	gap: 40px;
	width: 100%;
	padding-top: 40px;

	details {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 8px;
		color: #222;
		font-family: ITC Cheltenham Std;
		font-size: 22px;
		font-style: normal;
		font-weight: 400;
		line-height: 21px;
	}

	p {
		color: #222;
		font-family: 'Open Sans', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 22.4px;
		text-align: left;
		padding-top: 19px;
	}
	${EmotionBreakpoint('tablet')} {
		p {
			width: 650px;
		}
	}

	/* Hide the default browser marker */
	summary::-webkit-details-marker {
		display: none;
	}

	summary {
		list-style: none;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		position: relative;
		flex-grow: 1;
		font-family: escrow;
		font-size: 22px;
		font-style: normal;
		font-weight: 400;
		line-height: 29.4px;
		.law & {
			font-family: Noto serif;
		}
	}

	/* Set default marker to + and move it to the right */
	summary::before {
		content: '+';
		position: absolute;
		left: 900px;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
		font-size: 2rem;
	}
	${EmotionBreakpoint('tablet')} {
		summary::before {
			left: 650px;
		}
	}

	/* Change marker to - when <details> is open */
	details[open] summary::before {
		content: '-';
		font-size: 3rem;
	}

	${EmotionBreakpoint('mobile')} {
		gap: 20px;
		details {
			font-size: 18px;
		}
		summary {
			text-align: left;
			width: 300px;
		}
		summary::before {
			left: 330px;
		}
	}
`;

const BrosFaqs = ({ contentfulData }) => {
	return (
		<Layout>
			<HeadLineContainer>
				<Headline id='faqHeadline'>{contentfulData?.headLineFaq}</Headline>
				<SubHeadline id='faqSubHeadline'>
					{contentfulData?.subHeadLineFaq}
				</SubHeadline>
				<hr hrbackgroundcolor={contentfulData?.faqHrLineColor} />
			</HeadLineContainer>
			<FaqContianer>
				{contentfulData?.threeBrothersFaqs?.map((faq, index) => (
					<details key={index}>
						<summary>{faq?.fields?.title}</summary>
						<p
							dangerouslySetInnerHTML={{
								__html: faq?.fields?.answer,
							}}
						></p>
					</details>
				))}
			</FaqContianer>
		</Layout>
	);
};

export default BrosFaqs;
